<template>
	<div class="container">
		<input v-model="query" placeholder="Search song...." />
		<select v-model="music_type">
			<option disabled value="">Music genre</option>
			<option v-for="el in types" :key="el.id" :value="el.id">{{
				el.title
			}}</option>
		</select>
		<div class="resultsContainer" v-if="results">
			<div
				class="itemRow"
				v-for="el in results"
				:key="el.id"
				@click="() => upload(el)"
			>
				<img class="itemImage" :src="el.song_art_image_thumbnail_url" />
				<h1 class="title">{{ el.title }}</h1>
				<p class="artistName">{{ el.primary_artist.name }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { song_col, db, searchGenius, getGSong } from "../../firebase";

export default {
	data() {
		return {
			query: "",
			music_type: "",
			types: [],
			timeout: undefined,
			results: undefined,
		};
	},
	created() {
		this.getMusicTypes();
	},
	watch: {
		query() {
			clearTimeout(this.timeout);
			if (this.query) {
				this.timeout = setTimeout(async () => {
					const { data } = await searchGenius(this.query);
					this.results = data;
				}, 420);
			} else {
				this.results = null;
			}
		},
	},
	methods: {
		getMusicTypes() {
			db.collection("music_genre")
				.get()
				.then((docs) => (this.types = docs.docs.map((doc) => doc.data())));
		},
		parse(geniusFormat) {
			return {
				url: geniusFormat.url,
				media: geniusFormat.media,
				artist: geniusFormat.primary_artist.name,
				id: geniusFormat.id.toString(),
				lang: "en",
				music_type: this.music_type,
				nano_id: null,
				parsed: false,
				picture: geniusFormat.song_art_image_thumbnail_url,
				song_uri: null,
				title: geniusFormat.title,
			};
		},
		async upload(item) {
			if (!this.music_type) {
				alert("Missing music Genre.");
				return;
			}
			const id = item.id.toString();
			const res = await getGSong(id);
			let gsong = this.parse(res.data);
			const ref = song_col.doc(id);

			ref
				.get()
				.then((doc) =>
					doc.exists
						? alert(id + " Already selected.")
						: ref
								.set({ ...gsong, id })
								.then(() => alert(gsong.title + " saved!"))
				);
		},
	},
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	width: 66%;
	margin: auto;
	padding: 42px;
}
input,
select {
	border: 1px solid grey;
	font-size: 24px;
	margin: 15px;
	text-align: center;
	border-radius: 66px;
	padding: 4px;
}
select {
	cursor: pointer;
}
option {
	text-align: center;
}
.resultsContainer {
}
.itemRow {
	cursor: pointer;
	margin: 42px;
}
.itemImage {
	width: 200px;
	height: 200px;
}
.title {
	margin: 0;
}
.artistName {
	margin: 0;
}
</style>
